import { VerifiedUserInfo } from "@core-ts/clients/AuthenticationServiceClient";

export class VerifiedSession
{
    constructor(readonly userInfo: VerifiedUserInfo) { }
}